import { render } from "./InputTag.vue?vue&type=template&id=4238f3e2"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"

import "./InputTag.vue?vue&type=style&index=0&id=4238f3e2&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__